<template>
  <div class="mt-5">
    <div id="app" class="container mx-auto">
      <hooper :infiniteScroll="true" :autoPlay="true" :playSpeed="2000" :centerMode="true" :itemsToShow=1
        class="place-content-center">
        <slide>
          <img src="../picture/mg_1.png" />
        </slide>
        <slide>
          <img src="../picture/lindt.jpg" />
          <!-- <img src="../picture/lindt.jpg" class="place-content-end" /> -->
        </slide>
        <slide>
          <img src="../picture/クー.jpeg" />
        </slide>
        <slide>
          <img src="../picture/シュー.jpeg" />
        </slide>
        <hooper-navigation slot="hooper-addons" />
        <hooper-pagination slot="hooper-addons" />
      </hooper>
    </div>
  </div>

</template>

<script>
  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination
  } from 'hooper';
  import 'hooper/dist/hooper.css';


  export default {
    name: 'App',
    components: {
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination
    }
  }
</script>

<style lang="scss" scoped>
  .hooper {
    // padding: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border: 2px solid #fff;
    font-size: 30px;
    border-radius: 10px; //角丸
    min-height: 800px;
  }

  img {
    min-width: 100%;
    height: 800px;
    object-fit: cover;
  }
</style>